/* Guide « Trouver mon luminaire » — Plafonniers Design
   Cinq questions, aucune application tierce, aucune base de données.
   Le résultat est une vraie page collection filtrée par étiquettes :
   /collections/<budget>/<tag>+<tag>. Partageable, indexable, ajustable.

   Le comptage se fait via le gabarit collection.compte, qui ne renvoie
   qu'un nombre. Tant que la combinaison ne donne pas au moins MINIMUM
   modèles, on relâche le dernier critère : le visiteur doit toujours
   repartir avec un vrai choix, jamais avec une page vide ni un seul
   résultat.                                                              */
(function () {
  'use strict';

  var MINIMUM = 3;

  /* vocabulaire reconnu dans la phrase libre.
     Volontairement limité : mieux vaut ne rien retenir que retenir à tort. */
  var MOTS = [
    ['bambou',                          'matiere_bambou',          'bambou'],
    ['rotin|osier|tress',               'matiere_rotin',           'rotin'],
    ['bois|ch[eê]ne|noyer',             'matiere_bois',            'bois'],
    ['verre|opalin',                    'matiere_verre',           'verre'],
    ['m[ée]tal|acier|fer',              'matiere_metal',           'métal'],
    ['lin|tissu|toile',                 'matiere_tissu-lin',       'tissu'],
    ['papier|riz|lampion',              'matiere_papier',          'papier'],
    ['cristal|pampille',                'matiere_cristal',         'cristal'],
    ['plume',                           'matiere_plumes',          'plumes'],
    ['dor[ée]|laiton| or |cuivr',       'couleur_dore-laiton',     'doré'],
    ['noir',                            'couleur_noir',            'noir'],
    ['blanc',                           'couleur_blanc',           'blanc'],
    ['boule|globe|sph[èe]r|rond',       'forme_boule',             'boule'],
    ['nuage',                           'forme_nuage',             'nuage'],
    ['[ée]toile|lune',                  'forme_etoile',            'étoile et lune'],
    ['fleur|p[ée]tale',                 'forme_fleur',             'fleur'],
    ['cage|filaire',                    'forme_cage',              'cage'],
    ['lanterne',                        'forme_lanterne',          'lanterne'],
    ['origami|ondul',                   'forme_origami',           'origami'],
    ['plusieurs|multi|grappe',          'forme_multi-lampes',      'multi-lampes'],
    ['japon|zen|japandi|wabi',          'style_japandi',           'japonais'],
    ['industriel|loft|usine|edison',    'style_industriel',        'industriel'],
    ['vintage|r[ée]tro|ancien',         'style_vintage',           'vintage'],
    ['scandinav|nordique',              'style_scandinave',        'scandinave'],
    ['[ée]pur|minimalist|sobre|simple', 'style_minimaliste',       'minimaliste'],
    ['boh[èe]m|macram',                 'style_boheme',            'bohème'],
    ['cosy|chaleureu|douill|cocon',     'style_naturel',           'chaleureux'],
    ['enfant|b[ée]b[ée]|chambre de',    'piece_chambre-enfant',    'chambre d’enfant']
  ];

  function norm(s) {
    return (' ' + s + ' ').toLowerCase();
  }

  function lireLaPhrase(txt) {
    var vus = {}, tags = [], mots = [];
    var t = norm(txt);
    for (var i = 0; i < MOTS.length; i++) {
      var re = new RegExp(MOTS[i][0]);
      if (re.test(t) && !vus[MOTS[i][1]]) {
        vus[MOTS[i][1]] = 1;
        tags.push(MOTS[i][1]);
        mots.push(MOTS[i][2]);
      }
    }
    return { tags: tags.slice(0, 2), mots: mots.slice(0, 2) };
  }

  /* ---------------------------------------------------------------- */

  function init(racine) {
    if (!racine || racine.dataset.pdReady) return;
    racine.dataset.pdReady = '1';

    var rep = {};
    var etape = 0;
    var libre = { tags: [], mots: [] };

    var elStep  = racine.querySelector('[data-pd-step]');
    var elFill  = racine.querySelector('[data-pd-fill]');
    var elBack  = racine.querySelector('[data-pd-back]');
    var elRecap = racine.querySelector('[data-pd-recap]');
    var qs      = racine.querySelectorAll('[data-pd-q]');

    function tagsActuels() {
      var t = [];
      if (rep.piece) t.push(rep.piece);
      if (rep.ambiance) t.push(rep.ambiance);
      if (rep.matiere) t.push(rep.matiere);
      for (var i = 0; i < libre.tags.length; i++) t.push(libre.tags[i]);
      return t;
    }

    function url(base, tags) {
      var b = '/collections/' + (base || 'tous-les-luminaires');
      return tags.length ? b + '/' + tags.join('+') : b;
    }

    /* compte réel via le gabarit collection.compte ({% layout none %}) */
    function compter(base, tags) {
      return fetch(url(base, tags) + '?view=compte', { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.ok ? r.text() : '0'; })
        .then(function (t) { return parseInt(String(t).replace(/\D+/g, ''), 10) || 0; })
        .catch(function () { return -1; });
    }

    /* relâche le dernier critère tant qu'on n'a pas MINIMUM modèles.
       En dernier recours on élargit aussi le budget : mieux vaut proposer
       trois modèles un peu plus chers que n'en proposer qu'un seul.       */
    function resoudre() {
      var base = rep.budget || 'tous-les-luminaires';
      var tags = tagsActuels();
      var budgetElargi = false;
      function essai() {
        return compter(base, tags).then(function (n) {
          if (n >= MINIMUM || n === -1) return { base: base, tags: tags, n: n };
          if (tags.length > 0) { tags = tags.slice(0, -1); return essai(); }
          if (!budgetElargi && base !== 'tous-les-luminaires') {
            budgetElargi = true;
            base = 'tous-les-luminaires';
            tags = tagsActuels();
            return essai();
          }
          return { base: base, tags: tags, n: n };
        });
      }
      return essai();
    }

    function majRecap() {
      if (!elRecap) return;
      var libelles = [];
      var choisis = racine.querySelectorAll('[data-pd-opt][aria-pressed="true"]');
      for (var i = 0; i < choisis.length; i++) {
        if (!choisis[i].getAttribute('data-pd-opt')) continue;
        var b = choisis[i].querySelector('b');
        libelles.push(b ? b.textContent.trim() : choisis[i].textContent.trim());
      }
      for (var k = 0; k < libre.mots.length; k++) libelles.push(libre.mots[k]);
      elRecap.innerHTML = libelles.length
        ? '<b>Votre sélection</b>' + libelles.map(function (l) {
            return '<span class="pdG__chip">' + l + '</span>';
          }).join('')
        : '';
    }

    function montrer(i) {
      etape = Math.max(0, Math.min(i, qs.length - 1));
      for (var k = 0; k < qs.length; k++) qs[k].hidden = (k !== etape);
      if (elStep) elStep.textContent = 'Question ' + (etape + 1) + ' sur ' + qs.length;
      if (elFill) elFill.style.width = ((etape + 1) / qs.length * 100) + '%';
      if (elBack) elBack.hidden = (etape === 0);
      majRecap();
      var h = qs[etape].querySelector('.pdQ__title');
      if (h) h.setAttribute('tabindex', '-1'), h.focus({ preventScroll: true });
    }

    function terminer(btn) {
      var libelle = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Un instant…';
      resoudre().then(function (r) {
        window.location.href = url(r.base, r.tags);
      }).catch(function () {
        if (btn) btn.textContent = libelle;
        window.location.href = url(rep.budget, tagsActuels());
      });
    }

    racine.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-pd-opt]');
      if (opt) {
        var qid = opt.closest('[data-pd-q]').getAttribute('data-pd-q');
        rep[qid] = opt.getAttribute('data-pd-opt');
        var freres = opt.closest('[data-pd-q]').querySelectorAll('[data-pd-opt]');
        for (var i = 0; i < freres.length; i++) {
          freres[i].setAttribute('aria-pressed', String(freres[i] === opt));
        }
        if (etape < qs.length - 1) { montrer(etape + 1); } else { terminer(null); }
        return;
      }
      if (e.target.closest('[data-pd-back]')) { montrer(etape - 1); return; }
      if (e.target.closest('[data-pd-skip]')) {
        var q = qs[etape].getAttribute('data-pd-q');
        rep[q] = '';
        if (etape < qs.length - 1) { montrer(etape + 1); } else { terminer(null); }
        return;
      }
      var go = e.target.closest('[data-pd-go]');
      if (go) { terminer(go); }
    });

    var champ = racine.querySelector('[data-pd-free]');
    var lecture = racine.querySelector('[data-pd-read]');
    if (champ) {
      var minuteur;
      champ.addEventListener('input', function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(function () {
          libre = lireLaPhrase(champ.value);
          if (lecture) {
            lecture.innerHTML = champ.value.trim() === ''
              ? ''
              : (libre.mots.length
                  ? 'J’ai retenu&nbsp;: <em>' + libre.mots.join('</em>, <em>') + '</em>'
                  : 'Je n’ai rien reconnu dans cette phrase — ce n’est pas grave, les réponses précédentes suffisent.');
          }
          majRecap();
        }, 260);
      });
    }

    montrer(0);
  }

  function partout() {
    var n = document.querySelectorAll('[data-pd-guide]');
    for (var i = 0; i < n.length; i++) init(n[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', partout);
  } else {
    partout();
  }
  /* l'éditeur de thème recharge les sections sans recharger la page */
  document.addEventListener('shopify:section:load', partout);
})();